(function () {
  'use strict';

  /* @ngdoc object
   * @name events.vehicles.edit
   * @description
   *
   */
  angular
    .module('events.vehicles.edit', [
      'ui.router'
    ]);
}());
